module.exports = __webpack_public_path__ + "static/media/compare_68.f269ab06.svg";